export const lc = {
	bg: '#08080A',
	card: '#111114',
	el: '#18181B',
	brand: '#6B45FF',
	brandL: '#8B6AFF',
	brandP: '#C4B5FD',
	text: '#FAFAFA',
	sec: '#A1A1AA',
	mut: '#8E8E96',
	brd: 'rgba(255,255,255,0.06)',
	brdH: 'rgba(255,255,255,0.12)',
} as const
